import { useCallback, useRef } from "react";

export type EnqueueFn = <T>(task: () => Promise<T>) => Promise<T>;

// Run the enqueued tasks one after another, in the order they were enqueued;
// a failed task does not stop the ones after it.
const useSerialQueue = (): EnqueueFn => {
  // Resolves when the last task in line is done.
  const tailRef = useRef<Promise<void>>(Promise.resolve());

  return useCallback(<T>(task: () => Promise<T>): Promise<T> => {
    const result = tailRef.current.then(task);
    tailRef.current = result.then(
      () => {},
      () => {},
    );
    return result;
  }, []);
};

export default useSerialQueue;
